import React from "react";
import PortfolioConfigData from "config/portfolio-config.json";
import styles from "./simpleTable.module.scss";
import colorsStore from "shared/store/colorsStore";
import { formatItalianNumber } from "utils/formatUtils";

const DistributionTable = ({ dataObject }) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  if (!dataObject.data) {
    return null;
  }
  const total = dataObject.data.reduce((sum, row) => sum + row.weight, 0);
  const paletteArray =
    PortfolioConfigData.palettes[dataObject.configData.palette];
  return (
    <div className={styles.simpleTableContainer}>
      <div className={styles.simpleTable}>
        <table>
          <thead>
            <tr>
              <th>{dataObject.configData.label_table_left}</th>
              <th className={styles.thRight}>
                {dataObject.configData.label_table_right}
              </th>
            </tr>
          </thead>
          <tbody>
            {dataObject.data.map((row, index) => {
              const colorIndex = index % paletteArray.length;
              const displayLabel = dataObject.configData.rows
                ? dataObject.configData.rows[row.label] || row.label
                : row.label;
              return (
                <tr key={index}>
                  <td>
                    {dataObject.configData.type !== "table_simple" && (
                      <span
                        className={styles.colorBox}
                        style={{ backgroundColor: paletteArray[colorIndex] }}
                      />
                    )}

                    {displayLabel}
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      color:
                        row.weight > 0
                          ? colorsConfig.FinecoBlack
                          : colorsConfig.red,
                    }}
                  >
                    {row.label === "sharpe"
                      ? formatItalianNumber(row.weight, 3)
                      : formatItalianNumber(row.weight)}
                  </td>
                </tr>
              );
            })}
            {dataObject.configData.type !== "table_simple" && (
              <tr className="totalRow">
                <td>Totale</td>
                <td>{formatItalianNumber(total)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DistributionTable;
